import { render, staticRenderFns } from "./Page038.vue?vue&type=template&id=630a8371&scoped=true&"
import script from "./Page038.vue?vue&type=script&lang=js&"
export * from "./Page038.vue?vue&type=script&lang=js&"
import style0 from "./Page038.vue?vue&type=style&index=0&id=630a8371&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a8371",
  null
  
)

export default component.exports